module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACMSURBVHgBrZGhFcJAEERnFgo4JA6LSzqhBUqIogYUJdDClUAH4LB0QGx4Lzfs5cVEJrmvVv03O0M43/floA3uflYSAmZCKDKx2R2vH46y5xLRFLWWWJu2uK2XDTlD/tKUcEIhJFXmBbQoBoMReKEQlKJ1Pc5FUrqjExvb+9S/HrWAiCW4yEd9ZEd2/QHXGTdhxFxABgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/set3.png
// module id = fj+N
// module chunks = 1